
export const BASE_URL = 'https://event-back-end.onrender.com'